import React, { useState } from 'react';
import AddressAutocomplete from '../components/AddressAutocomplete';
import { addReservation } from '../api';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/AddressAutocomplete.css';

function ReservationForm() {
  const [reservation, setReservation] = useState({
    user_id: '',
    passenger_first_name: '',
    passenger_last_name: '',
    passenger_email: '',
    passenger_phone: '',
    trip_type: '',
    pickup_address: '',
    dropoff_address: '',
    airline: '',
    flight_number: '',
    pickup_datetime: '',
    vehicle_type: '',
    passenger_count: '',
    luggage_count: '',
    car_seat_needed: '',
    booster_seat_needed: '',
    notes: ''
  });
  const [reservationMsg, setReservationMsg] = useState('');
  const [step, setStep] = useState(1);

  const handleReservationChange = e => {
    setReservation({ ...reservation, [e.target.name]: e.target.value });
  };

  const nextStep = () => {
    // Validate required fields for each step
    if (step === 1) {
      if (!reservation.passenger_first_name || !reservation.passenger_last_name || !reservation.passenger_email || !reservation.passenger_phone) {
        setReservationMsg('Please fill all required personal info fields.');
        return;
      }
    }
    if (step === 2) {
      if (!reservation.pickup_address || !reservation.dropoff_address || !reservation.pickup_datetime || !reservation.vehicle_type || !reservation.passenger_count) {
        setReservationMsg('Please fill all required trip details fields.');
        return;
      }
    }
    setReservationMsg('');
    setStep(step + 1);
  };

  const prevStep = () => {
    setReservationMsg('');
    setStep(step - 1);
  };

  const submitReservation = async e => {
    e.preventDefault();
    setReservationMsg('');
    try {
        const payload = {
  ...reservation,
  passenger_count: reservation.passenger_count ? Number(reservation.passenger_count) : undefined,
  luggage_count: reservation.luggage_count ? Number(reservation.luggage_count) : undefined,
  car_seat_needed: reservation.car_seat_needed === 'yes',
  booster_seat_needed: reservation.booster_seat_needed === 'yes'
};
      await addReservation(payload);
      setReservationMsg('Reservation submitted!');
      setReservation({
        user_id: '',
        passenger_first_name: '',
        passenger_last_name: '',
        passenger_email: '',
        passenger_phone: '',
        trip_type: '',
        pickup_address: '',
        dropoff_address: '',
        airline: '',
        flight_number: '',
        pickup_datetime: '',
        vehicle_type: '',
        passenger_count: '',
        luggage_count: '',
        car_seat_needed: '',
        booster_seat_needed: '',
        notes: ''
      });
      setStep(1);
    } catch (err) {
      setReservationMsg('Error submitting reservation.');
    }
  };

  return (
    <section className="py-5" style={{background:'#f8f9fa', width:'100vw', margin:0, padding:0, overflowX:'hidden'}}>
      <div className="d-flex justify-content-center align-items-center" style={{minHeight:'80vh', width:'100vw', margin:0}}>
  <div className="card shadow-lg border-0" style={{maxWidth:750, minWidth:340, width:'100%', padding:'2.5rem 2rem', borderRadius:'2rem', background:'#fff', boxShadow:'0 8px 32px 0 rgba(31,38,135,0.12)'}}>
          <h2 className="mb-4 text-center">Book a Reservation</h2>
          <form onSubmit={submitReservation}>
          {/* Stepper */}
          <div className="mb-4 d-flex justify-content-center align-items-center gap-3">
            <div className={`rounded-circle border border-2 ${step>=1?'bg-success text-white border-success':'bg-light text-secondary border-secondary'}`} style={{width:36,height:36,display:'flex',alignItems:'center',justifyContent:'center'}}>1</div>
            <div className={`border-top border-2 ${step>=2?'border-success':'border-secondary'}`} style={{width:40}}></div>
            <div className={`rounded-circle border border-2 ${step>=2?'bg-success text-white border-success':'bg-light text-secondary border-secondary'}`} style={{width:36,height:36,display:'flex',alignItems:'center',justifyContent:'center'}}>2</div>
            <div className={`border-top border-2 ${step>=3?'border-success':'border-secondary'}`} style={{width:40}}></div>
            <div className={`rounded-circle border border-2 ${step===3?'bg-success text-white border-success':'bg-light text-secondary border-secondary'}`} style={{width:36,height:36,display:'flex',alignItems:'center',justifyContent:'center'}}>3</div>
          </div>
          {/* Step 1: Personal Info */}
          {step === 1 && (
            <div className="row mb-3" style={{margin:0}}>
              <div className="col-md-6 mb-3">
                <input type="text" className="form-control" placeholder="First Name" name="passenger_first_name" value={reservation.passenger_first_name} onChange={handleReservationChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <input type="text" className="form-control" placeholder="Last Name" name="passenger_last_name" value={reservation.passenger_last_name} onChange={handleReservationChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <input type="email" className="form-control" placeholder="Email Address" name="passenger_email" value={reservation.passenger_email} onChange={handleReservationChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <input type="tel" className="form-control" placeholder="Phone Number" name="passenger_phone" value={reservation.passenger_phone} onChange={handleReservationChange} required />
              </div>
              <div className="col-12 d-flex justify-content-end">
                <button type="button" className="btn btn-primary" onClick={nextStep}>Next</button>
              </div>
            </div>
          )}
          {/* Step 2: Trip Details */}
          {step === 2 && (
            <div className="row mb-3" style={{margin:0}}>
              <div className="col-md-6 mb-3" style={{position:'relative', zIndex:3}}>
                <AddressAutocomplete
                  name="pickup_address"
                  value={reservation.pickup_address}
                  onChange={handleReservationChange}
                  placeholder="Pickup Address"
                  className="form-control"
                  required
                />
              </div>
              <div className="col-md-6 mb-3" style={{position:'relative', zIndex:2}}>
                <AddressAutocomplete
                  name="dropoff_address"
                  value={reservation.dropoff_address}
                  onChange={handleReservationChange}
                  placeholder="Dropoff Address"
                  className="form-control"
                  required
                />
              </div>
              <div className="col-md-6 mb-3">
                <input type="datetime-local" className="form-control" placeholder="Pickup Date & Time" name="pickup_datetime" value={reservation.pickup_datetime} onChange={handleReservationChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <select className="form-select" name="vehicle_type" value={reservation.vehicle_type} onChange={handleReservationChange} required>
                  <option value="">Select Vehicle Type</option>
                  <option value="Sedan">Sedan</option>
                  <option value="SUV">SUV</option>
                  <option value="Sprinter">Sprinter</option>
                  <option value="Stretch Limo">Stretch Limo</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <input type="number" className="form-control" placeholder="Passenger Count" name="passenger_count" value={reservation.passenger_count} onChange={handleReservationChange} required min="1" />
              </div>
              <div className="col-12 d-flex justify-content-between">
                <button type="button" className="btn btn-secondary" onClick={prevStep}>Back</button>
                <button type="button" className="btn btn-primary" onClick={nextStep}>Next</button>
              </div>
            </div>
          )}
          {/* Step 3: Extras */}
          {step === 3 && (
            <div className="row mb-3" style={{margin:0}}>
              <div className="col-md-6 mb-3">
                <select className="form-select" name="trip_type" value={reservation.trip_type} onChange={handleReservationChange}>
                  <option value="">Select Trip Type</option>
                  <option value="One Way">One Way</option>
                  <option value="Round Trip">Round Trip</option>
                  <option value="Multi Stop">Multi Stop</option>
                  <option value="Airport Transfer">Airport Transfer</option>
                  <option value="Hourly Service">Hourly Service</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <input type="text" className="form-control" placeholder="Airline (if applicable)" name="airline" value={reservation.airline} onChange={handleReservationChange} />
              </div>
              <div className="col-md-6 mb-3">
                <input type="text" className="form-control" placeholder="Flight Number (if applicable)" name="flight_number" value={reservation.flight_number} onChange={handleReservationChange} />
              </div>
              <div className="col-md-6 mb-3">
                <input type="number" className="form-control" placeholder="Luggage Count" name="luggage_count" value={reservation.luggage_count} onChange={handleReservationChange} min="0" />
              </div>
              <div className="col-md-6 mb-3">
                <select className="form-select" name="car_seat_needed" value={reservation.car_seat_needed} onChange={handleReservationChange} >
                  <option value="">Car Seat Needed?</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <select className="form-select" name="booster_seat_needed" value={reservation.booster_seat_needed} onChange={handleReservationChange} >
                  <option value="">Booster Seat Needed?</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
              <div className="col-12 mb-3">
                <textarea className="form-control" placeholder="Notes (optional)" name="notes" value={reservation.notes} onChange={handleReservationChange} rows="2"></textarea>
              </div>
              <div className="col-12 d-flex justify-content-between">
                <button type="button" className="btn btn-secondary" onClick={prevStep}>Back</button>
                <button type="submit" className="btn btn-success">Submit Reservation</button>
              </div>
            </div>
          )}
          {reservationMsg && <div className="mt-3 alert alert-info">{reservationMsg}</div>}
          </form>
        </div>
      </div>
    </section>
  );
}

export default ReservationForm;
